import I18n from 'I18n';
import { FlywheelDefaultCardAction } from '../default/FlywheelDefaultCardAction';
import { jsx as _jsx } from "react/jsx-runtime";
const FlywheelCompanyCardAction = props => {
  const {
    associatedObjectsIds,
    canEditAssociation
  } = props;
  const hasExistingAssociation = associatedObjectsIds.length > 0;
  return /*#__PURE__*/_jsx(FlywheelDefaultCardAction, Object.assign({}, props, {
    canEditAssociation: canEditAssociation && !hasExistingAssociation // We only allow for one company association so if there is an existing association the the Add button should be hidden
    ,
    canEditAssociationMessageOverride: hasExistingAssociation ? I18n.text('flywheel.FlywheelCompanyCardAction.canEditAssociationMessageOverride') : undefined,
    createEnabledOverride: false,
    disabledCreateTabTooltipOverride: I18n.text('flywheel.FlywheelCompanyCardAction.disabledCreateTabTooltipOverride'),
    forceSingleSelectAssociation: true // Only a single company can be associated to an object
  }));
};
export default FlywheelCompanyCardAction;